module.exports = require("./ru-BY");